/* Search results page controller. Handles: sort <select> auto-submit,
   floating quick-add-to-cart on single-variant product results, and
   "load more" pagination with auto-infinite-scroll via Shopify's Section
   Rendering API -- same mechanism as assets/collection-page.js -- instead
   of classic numbered pagination links.
   Works with JS disabled too: the load-more button is a real link and
   the sort <select> lives in a real GET form -- this file only
   intercepts to make it faster when JS is available. */
(function () {
  'use strict';

  function wireQuickAdd(btn) {
    if (!btn || btn.dataset.spWired === '1') return;
    btn.dataset.spWired = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (rootPath.slice(-1) !== '/') rootPath += '/';

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.classList.remove('is-added');
          }, 1800);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.spInit === '1') return;
    root.dataset.spInit = '1';

    var sectionId = root.dataset.sectionId;
    var grid = root.querySelector('.search-page__grid');
    var count = root.querySelector('.search-page__count');
    var loadMoreWrap = root.querySelector('.search-page__load-more');
    var loadMoreBtn = root.querySelector('.search-page__load-btn');
    var sentinel = root.querySelector('.search-page__sentinel');
    var isFetching = false;

    // ---- Sort auto-submit ----
    root.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });

    // ---- Floating quick-add (single-variant products only) ----
    root.querySelectorAll('[data-quick-add]').forEach(wireQuickAdd);

    // ---- Load more / infinite scroll ----
    function loadMore(url) {
      if (!url || isFetching) return;
      isFetching = true;
      if (loadMoreBtn) loadMoreBtn.classList.add('is-loading');
      var fetchUrl = url.indexOf('section_id=') === -1
        ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId)
        : url;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('.search-page__grid > li');
          if (grid && newItems.length) {
            newItems.forEach(function (li) {
              grid.appendChild(li);
              li.querySelectorAll('[data-quick-add]').forEach(wireQuickAdd);
            });
          }
          var newLoadMore = doc.querySelector('.search-page__load-more');
          if (loadMoreWrap && newLoadMore) {
            var nextHasBtn = newLoadMore.querySelector('.search-page__load-btn');
            if (nextHasBtn) {
              if (loadMoreBtn) {
                loadMoreBtn.href = nextHasBtn.getAttribute('href');
                loadMoreBtn.classList.remove('is-loading');
              }
            } else {
              loadMoreWrap.remove();
            }
          } else if (loadMoreWrap) {
            loadMoreWrap.remove();
          }
        })
        .catch(function () {
          if (loadMoreBtn) loadMoreBtn.classList.remove('is-loading');
        })
        .finally(function () {
          isFetching = false;
        });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        loadMore(loadMoreBtn.getAttribute('href'));
      });
    }

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && loadMoreBtn && loadMoreBtn.getAttribute('href') && !isFetching) {
            loadMore(loadMoreBtn.getAttribute('href'));
          }
        });
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-search-page]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
